module.exports = __webpack_public_path__ + "static/media/laptop~APFZZBcn.d79c0809.svg";